import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";

import { Dialog, Notify } from "../../components/index";
import homeStore from "../../stores/homeStore";
import { editArticlesApi } from "../../apis";

import "./dialog.scss";

interface Props {
  visible: boolean;
  info: any;
  onSuccess?: (values: any) => void;
}

const EditInfoDialog: React.FC<Props> = (props: Props) => {
  const { visible, info, onSuccess = () => {} } = props;
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { setEditInfo } = homeStore();
  const [isPosted, setIsPosted] = useState(true);

  const onClose = () => {
    setEditInfo(false);
  };

  const onFinish = async (values: any) => {
    if (isPosted) {
      setIsPosted(false);
      const { title, summary, domainName, originalLink } = values;
      try {
        const res = await editArticlesApi(info.id, {
          article: {
            title,
            summary,
            domain_name: domainName,
            original_link: originalLink,
          },
        });
        form.resetFields();
        onSuccess(res);
      } catch (error: any) {
        // 失败提示
        if (error.msg) {
          Notify.error({
            message: error.msg,
            className: "notify-not-description",
            duration: 3,
          });
        }
      }
      onClose();
      setIsPosted(true);
    }
  };

  const onFieldsChange = async () => {
    const { title, summary, domainName, originalLink } = form.getFieldsValue();
    const posted = title && summary && domainName && originalLink;
    setIsPosted(
      !!posted &&
        form.getFieldsError().filter(({ errors }) => errors.length).length === 0
    );
  };

  useEffect(() => {
    // api();
    onFieldsChange();
  }, [visible]);

  return (
    <Dialog {...props} onCancel={onClose} style={{ padding: "15px 24px 20px" }}>
      <div className="edit-info-dialog">
        <p>编辑内容</p>
        <Form
          name="editInfo"
          onFinish={onFinish}
          onFieldsChange={onFieldsChange}
          autoComplete="off"
          form={form}
          layout="vertical"
          initialValues={info || {}}
        >
          <Form.Item
            label="标题"
            name="title"
            rules={[{ required: true, message: "请输入标题" }]}
          >
            <Input placeholder="请输入标题" />
          </Form.Item>
          <Form.Item
            label="摘要"
            name="summary"
            rules={[{ required: true, message: "请输入平台摘要" }]}
          >
            <TextArea
              style={{ height: 120, resize: "none" }}
              placeholder="请输入平台摘要"
            />
          </Form.Item>
          <Form.Item
            label="来源平台"
            name="domainName"
            rules={[{ required: true, message: "请输入平台名称" }]}
          >
            <Input placeholder="请输入平台名称" />
          </Form.Item>
          <Form.Item
            label="案例URL"
            name="originalLink"
            rules={[
              { required: true, message: "请输入您要推荐的文章链接地址" },
              {
                pattern:
                  /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i,
                message: "您提交的链接格式不对，请重新提交",
              },
            ]}
          >
            <Input placeholder="请输入您要推荐的文章链接地址" />
          </Form.Item>
          <div
            className={`edit-info-dialog__btn ${!isPosted && "edit-info-dialog__btn--disable"}`}
            onClick={() => form.submit()}
          >
            保存
          </div>
        </Form>
      </div>
    </Dialog>
  );
};

export default EditInfoDialog;
